import { CNavItem } from '@coreui/react';

import t from '../../../locations/translations';
import { RouteRule } from '../../../routes/RouteManager';

const navigation = [
	{
		component: CNavItem,
		name: t('navigation.products'),
		to: RouteRule.products.path,
	},
	{
		component: CNavItem,
		name: t('navigation.store'),
		to: RouteRule.stores.path,
	},
	{
		component: CNavItem,
		name: t('navigation.distribution'),
		to: RouteRule.distribution.path,
	},
	{
		component: CNavItem,
		name: t('navigation.aboutUs'),
		to: RouteRule.aboutUs.path,
	},
	{
		component: CNavItem,
		name: t('navigation.contacts'),
		to: RouteRule.contact.path,
	},
];

export default navigation;
